import { IFrameApi } from "./iframe-api"
import { RemoteProxy } from "penpal/dist/penpal"
import { shallow as shallowEquals } from "zustand/shallow"
import { useEffect, useRef } from "react"
import { IFCViewerV4ConfigOptions } from "./config"
import PublishUtils from "../../../helpers/PublishUtils"
import { useLatest } from "../../../hooks/use-latest"

export function useSyncModelUrls(conf: {
  type: "ifc" | "frag"
  iframeApi: RemoteProxy<IFrameApi> | null | undefined
  urls: string | null | undefined
  multipleselectparametertype: IFCViewerV4ConfigOptions["multipleselectparametertype"]
  onModelsLoaded?: () => void
}) {
  const prevUrls = useRef<string[]>([])
  const latestConf = useLatest(conf)

  useEffect(() => {
    const conf = latestConf.current
    if (!conf.iframeApi) return

    async function sync() {
      const urls = (() => {
        if (!conf.urls) return []
        try {
          return PublishUtils.parseMultiplePropValue(
            conf.multipleselectparametertype,
            conf.urls
          ) as string[]
        } catch (e) {
          console.error(`Failed parsing ${conf.type} urls`, e)
          return []
        }
      })()

      const sameUrls = shallowEquals(urls, prevUrls.current)
      if (sameUrls) return

      prevUrls.current = urls

      const absoluteUrls = urls.map(url => `${window.location.origin}${url}`)

      await (conf.type === "ifc"
        ? conf.iframeApi!.setIfcUrls(absoluteUrls)
        : conf.iframeApi!.setFragmentUrls(absoluteUrls))

      conf.onModelsLoaded?.()
    }

    sync().catch(e => console.error(`Error syncing ${conf.type} files`, e))
  }, [
    conf.type,
    conf.urls,
    latestConf
  ])
}
